import { Box } from '@mui/material';
import { Control, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SearchFilters } from '../types/search.types';
import { AddressAutocompleteField } from '@/shared/components/forms';

interface AddressFilterProps {
  readonly control: Control<SearchFilters>;
  readonly setValue: UseFormSetValue<SearchFilters>;
}

export function AddressFilter({ control, setValue }: Readonly<AddressFilterProps>) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <AddressAutocompleteField
        name="address"
        control={control}
        label={t('search.address.label')}
        placeholder={t('search.address.placeholder')}
        onAddressSelected={suggestion => {
          // Set coordinates for distance calculation
          if (suggestion.coordinates) {
            setValue('latitude', suggestion.coordinates.lat);
            setValue('longitude', suggestion.coordinates.lng);
          }
        }}
      />
    </Box>
  );
}
